import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginAdmin } from "../store/authSlice";
import { useNavigate } from "react-router";


function AdminLogin() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const [serverError, setServerError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  // If already logged in, don't show login page
  useEffect(() => {
    if (user) {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  const onSubmit = async (data) => {
    setServerError("");
   
    const resultAction = await dispatch(loginAdmin(data));

    if (loginAdmin.fulfilled.match(resultAction)) {
      navigate("/", { replace: true });
    } else {
      const payloadMessage = resultAction.payload;
      const fallbackMessage = resultAction.error?.message;
      setServerError(payloadMessage || fallbackMessage || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-950 to-black px-4">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full max-w-sm rounded-2xl bg-[#0f1c2e]/95 backdrop-blur
                   shadow-[0_20px_50px_rgba(0,0,0,0.35)]
                   px-8 py-10"
      >
        {/* Brand */}
        <div className="text-center mb-6">
          <h1 className="text-3xl font-extrabold tracking-wide">
            <span className="text-white">MIND</span>{" "}
            <span className="text-cyan-500">CODERS</span>
          </h1>
          <span className="inline-block mt-2 px-3 py-1 text-xs font-semibold
                           rounded-full bg-[#1ec1d1]/15 text-[#1ec1d1] border border-[#1ec1d1]/30">
            ADMIN LOGIN
          </span>
        </div>

        {/* Username */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-slate-300 mb-1">
            Username
          </label>
          <input
            type="email"
            placeholder="admin@example.com"
            {...register("email", { required: "Email is required" })}
            className="w-full px-4 py-2.5 rounded-lg border border-[#1d3350] bg-[#0a1626] text-slate-100 placeholder:text-slate-500
                       focus:outline-none focus:ring-2 focus:ring-cyan-500
                       focus:border-cyan-500 transition"
          />
          {errors.email && (
            <p className="text-xs text-red-600 mt-1">
              {errors.email.message}
            </p>
          )}
        </div>

        {/* Password */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-slate-300 mb-1">
            Password
          </label>
          <input
            type="password"
            placeholder="••••••••"
            {...register("password", { required: "Password is required" })}
            className="w-full px-4 py-2.5 rounded-lg border border-[#1d3350] bg-[#0a1626] text-slate-100 placeholder:text-slate-500
                       focus:outline-none focus:ring-2 focus:ring-cyan-500
                       focus:border-cyan-500 transition"
          />
          {errors.password && (
            <p className="text-xs text-red-600 mt-1">
              {errors.password.message}
            </p>
          )}
        </div>

        {serverError && (
          <p className="mb-3 text-sm text-red-600 text-center">{serverError}</p>
        )}

        {/* Button */}
        <button
          disabled={isSubmitting}
          className="w-full py-3 rounded-lg font-semibold text-white
                     bg-gradient-to-r from-[#0a3355] to-[#1ec1d1]
                     hover:brightness-110
                     transition-all duration-200
                     disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isSubmitting ? "Authenticating..." : "Login as Admin"}
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
